/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GuardrailModel {
    getFixupPrototypeFunction() { return GuardrailModel.fixupPrototype; }

    static newInstance(model: Partial<GuardrailModel>): GuardrailModel {
        let obj = Object.assign(new GuardrailModel(), model);
        GuardrailModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GuardrailModel>): GuardrailModel {
        if (!model) return null;
        return GuardrailModel.newInstance(<GuardrailModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GuardrailModel) {
        if (!obj) return;

        models.GuardrailModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GuardrailModel): boolean {
        Object.setPrototypeOf(obj, GuardrailModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Category of the guardrail
     */
    category: string;

    /**
     * Name of the guardrail
     */
    name: string;

    /**
     * Label of the guardrail
     */
    label: string;

}
